import { render, staticRenderFns } from "./disiplin.vue?vue&type=template&id=17ed1d9c&"
import script from "./disiplin.vue?vue&type=script&lang=js&"
export * from "./disiplin.vue?vue&type=script&lang=js&"
import style0 from "./disiplin.vue?vue&type=style&index=0&id=17ed1d9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports